import "core-js/modules/es.number.constructor";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

var AppDialog = /*#__PURE__*/function (_Vue) {
  _inherits(AppDialog, _Vue);

  var _super = _createSuper(AppDialog);

  function AppDialog() {
    var _this;

    _classCallCheck(this, AppDialog);

    _this = _super.apply(this, arguments);
    _this.model = false;
    _this.newCaseInput = {
      name: '',
      gender: '',
      birthday: '',
      phone: '',
      memo: ''
    };
    return _this;
  }

  _createClass(AppDialog, [{
    key: "mounted",
    value: function mounted() {
      this.model = this.value;
    }
  }, {
    key: "closeDialog",
    value: function closeDialog() {
      return false;
    }
  }, {
    key: "cancelDialog",
    value: function cancelDialog() {
      this.closeDialog();
    }
  }, {
    key: "valueChanged",
    value: function valueChanged() {
      this.model = this.value;
    }
  }, {
    key: "confirmDialog",
    value: function confirmDialog() {}
  }]);

  return AppDialog;
}(Vue);

__decorate([Prop(Boolean)], AppDialog.prototype, "value", void 0);

__decorate([Prop({
  type: [Number, String],
  default: 430
})], AppDialog.prototype, "width", void 0);

__decorate([Prop({
  type: [Number, String],
  default: 238
})], AppDialog.prototype, "height", void 0);

__decorate([Prop({
  type: String,
  default: 'Confirm'
})], AppDialog.prototype, "title", void 0);

__decorate([Prop({
  type: String,
  default: ''
})], AppDialog.prototype, "text", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppDialog.prototype, "disabled", void 0);

__decorate([Prop({
  type: String,
  default: '确定'
})], AppDialog.prototype, "confirmText", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], AppDialog.prototype, "showCancel", void 0);

__decorate([Emit('input')], AppDialog.prototype, "closeDialog", null);

__decorate([Emit('cancel')], AppDialog.prototype, "cancelDialog", null);

__decorate([Watch('value')], AppDialog.prototype, "valueChanged", null);

__decorate([Emit('confirm')], AppDialog.prototype, "confirmDialog", null);

AppDialog = __decorate([Component], AppDialog);
export default AppDialog;